export default "__VITE_ASSET__DTb9GMtI__"